var SiteDefinitions = {
	FieldNew: {
		Index: 0,
		Type: "Text",
		Name: "",
		StatusId: 1,
		RevisionId: 0,
		Caption: "",
		Group: "",
		Visible: 1,
		Default: "",
		NewValue: "",
		Style: "",
		Tooltip: "",
		Placeholder: "",
		Description: "",
		New: 1,
		Update: 1,
		List: 1,
		WhereSign: "",
		WhereText: "",
		Mandatory: 0,
		RegEx: "",
		InCaption: 1,
		InKey: 0
	},
	Session: {
		Status: false,
		Id: 0,
		UID: '',
		SiteId: 0,
		SiteUID: "",
		SiteData: { SiteId: 0, SiteUID: "" },
		InfoId: 0,
		InfoUID: "",
		InfoData: { InfoId: 0, InfoUID: "" },
		UserId: 0,
		UserUID: "",
		UserData: { UserId: 0, UserUID: "visitor", FullName: "Anonimus" }
	},
	Object: {
		ObjectId: null,
		ObjectUID: null,
		Caption: null,
		ExecCount: 0,
		InfoId: null,
		OrderBy: null,
		ParentId: 0,
		Properties: {},
		StatusId: 1,
		TypeId: null
	},
	Form: {
		InfoId: 0,
		UserId: 0,
		StatusId: 1,
		FolioId: null,
		FolioUID: null,
		FolioName: null,
		TypeId: null,
		TypeUID: null,
		TypeVisibility: 4,
		StatusId: 1,
		FolioVer: 0,
		Caption: "",
		Description: "",
	},
	Folio: {
		InfoId: 0,
		UserId: 0,
		StatusId: 1,
		TypeId: 130,
		ParentId: 0,
		FolioUID: null,
		FolioName: "",
		FolioStatusId: 1,
		FolioVer: 0,
		FolioShow: 1,
		Caption: "",
		Description: "",
		Filters: "",
		Behavior: "",
		DataTypeId: 2,
		DataQuery: "",
		DataSource: "",
		DataSelect: "",
		DataEvent: "",
		DataMeta: "",
		DataConnection: "",
		PageName: "",
		PageTemplate: "",
		PageTypeId: 1,
		PageHtml: "",
		PageEval: "",
	},
	Type: {
		TypeUID: null,
		InfoId: 0,
		UserId: 0,
		StatusId: 1,
		RevisionId: null,
		PartitionId: null,
		Visibility: null,
		ParentUID: null,
		KindId: 0,
		Privilege: 0,
		Caption: "Messages",
		Description: null,
		Properties: null,
		Behavior: null,
		Views: null,
		SqlUID: null,
		TableNameMap: null,
		SystemTable: null
	},
	Controls: [
		{ Type: 'Text', Text: 'Text', Icon: 'font' },
		{ Type: 'Number', Text: 'Number', Icon: 'hashtag' },
		{ Type: 'Money', Text: 'Money', Icon: 'dollar' },
		{ Type: 'Date', Text: 'Date', Icon: 'calendar' },
		{ Type: 'Time', Text: 'Time', Icon: 'clock-o' },
		{ Type: 'Memo', Text: 'Memo', Icon: 'clone' },
		{ Type: 'File', Text: 'File', Icon: 'file' },
		{ Type: 'Checkbox', Text: 'Checkbox', Icon: 'check' },
		{ Type: 'Switch', Text: 'Switch', Icon: 'toggle-on' },
		{ Type: 'Image', Text: 'Image', Icon: 'picture-o' },
		{ Type: 'Color', Text: 'Color', Icon: 'tint' },
		{ Type: 'Select', Text: 'Select', Icon: 'list' },
		{ Type: 'Selectize', Text: 'Selectize', Icon: 'cc' }
	],
	ControlsInput: [
		{ Type: 'Code', Text: 'Code', Icon: 'hashtag' }
		, { Type: 'Text', Text: 'Text', Icon: 'font' }
		, { Type: 'Number', Text: 'Number', Icon: 'hashtag' }
		, { Type: 'Date', Text: 'Date', Icon: 'calendar' }
		, { Type: 'Time', Text: 'Time', Icon: 'clock-o' }
		, { Type: 'Memo', Text: 'Memo', Icon: 'clone' }
		, { Type: 'File', Text: 'File', Icon: 'file' }
		, { Type: 'Checkbox', Text: 'Checkbox', Icon: 'check' }
		, { Type: 'Image', Text: 'Image', Icon: 'picture-o' }
		, { Type: 'Color', Text: 'Color', Icon: 'tint' }
		, { Type: 'Select', Text: 'Select', Icon: 'list' }
		, { Type: 'Selectize', Text: 'Selectize', Icon: 'cc' }
		, { Type: 'Section', Text: 'Section', Icon: 'tint' }
	],
	Devices: [
		{ Type: 'globe', Text: 'Globe', Icon: 'icon md-globe' }
		, { Type: 'tablet', Text: 'Tablet', Icon: 'icon md-tablet' }
		, { Type: 'smartphone', Text: 'Smartphone', Icon: 'icon md-smartphone' }
		, { Type: 'tv', Text: 'TV', Icon: 'icon md-tv' }
		, { Type: 'laptop', Text: 'Laptop', Icon: 'icon md-laptop' }
		, { Type: 'desktop', Text: 'Desktop', Icon: 'icon md-desktop-windows' }
		, { Type: 'skype', Text: 'Skype', Icon: 'fa fa-skype' }
		, { Type: 'telegram', Text: 'Telegram', Icon: 'fa fa-telegram' }
	],
	UserStatuses: {
		G: { Type: 'G', Text: 'Guest', Icon: 'icon md-globe', Color: 'warning' },
		U: { Type: 'U', Text: 'User', Icon: 'icon md-globe', Color: 'success' },
		M: { Type: 'M', Text: 'Moderator', Icon: 'icon md-tablet', Color: 'info' },
		A: { Type: 'A', Text: 'Administrator', Icon: 'icon md-smartphone', Color: 'primary' },
		D: { Type: 'D', Text: 'Deleted', Icon: 'icon md-smartphone', Color: 'danger' },
		P: { Type: 'P', Text: 'Pending', Icon: 'icon md-smartphone', Color: 'warning' },
		B: { Type: 'B', Text: 'Banned', Icon: 'icon md-smartphone', Color: 'warning' }
	},
	Google: {
		MapSmall: {
			Options: {
				mapTypeId: 'roadmap',
				scrollwheel: false,
				disableDefaultUI: true,
				zoomControl: true
			}
		}
	},
	Integration: {
		Storage: {
			Dropbox: {
				Name: "Dropbox"
			},
			ownCloud: {
				Name: "ownCloud"
			}
		},
		EX: {
			GoogleMaps: { Type: 'GoogleMaps', Text: 'Google Maps', Icon: 'icon md-globe', Color: 'success' }
			, GoogleLogin: { Type: 'M', Text: 'Google Login', Icon: 'icon md-tablet', Color: 'info' }
			, FacebookLogin: { Type: 'A', Text: 'Facebook Login', Icon: 'icon md-smartphone', Color: 'primary' }
			, LinkedInLogin: { Type: 'D', Text: 'LinkedIn Login', Icon: 'icon md-smartphone', Color: 'danger' }
			, Instagram: { Type: 'P', Text: 'Instagram', Icon: 'icon md-smartphone', Color: 'warning' }
		}
	},
	Services: {
		Info: {
			Name: 'Share-Info',
			SqlName: 'Share.Info',
			Rows: 'CacheData.Info',
			Row: 'Info',
			Behavior: {
				Key: "InfoUID",
				Json: "Config",
				singleRow: true,
				rootRefresh: true
			}
		},
		Settings: {
			Name: 'Share-Settings',
			SqlName: 'Share.Settings',
			Rows: 'CacheData.Settings',
			Row: 'Settings',
			Behavior: {
				Key: "InfoUID",
				Json: "Config",
				singleRow: true,
				rootRefresh: true
			}
		},
		Products: {
			Name: 'Share-Products',
			SqlName: 'Share.Products',
			Rows: 'CacheData.Products',
			Row: 'Product',
			Behavior: {
				Key: "DataUID",
				rootRefresh: true
			}
		},
		Forms: {
			Name: 'Share-Forms'
			, Rows: 'CacheData.Forms'
			, Row: 'Page'
			, Behavior: {
				Key: "PageUID"
				, rootRefresh: true
			}
		}
		, FormsPublish: {
			Name: 'Share-Forms-Publish'
			, Rows: 'CacheData.FormsPublish'
			, Row: 'Page'
			, Behavior: {
				Key: "PageUID"
				, rootRefresh: true
			}
		}
		, Flows: {
			Name: 'Share-Flows'
			, Rows: 'CacheData.Flows'
			, Row: 'Flow'
			, Behavior: {
				Key: "FlowUID"
			}
		}
		, Users: {
			Name: 'Share-Users'
			, Rows: 'CacheData.Users'
			, Row: 'User'
			, Behavior: {
				Key: "UserUID"
			}
		},
		UserCurrent: {
			Name: 'Share.User.Current',
			Rows: 'CacheData.UserCurrent',
			Behavior: {
				Key: "UserUID",
				singleRow: true,
				rootRefresh: true
			}
		},
		UserActivity: {
			Name: 'Share-User-Activity'
			, Rows: 'Activity'
			, Behavior: {
			}
		}
		, Schemas: {
			Name: 'Share-Forms-Types'
			, Rows: 'CacheData.Schemas'
			, Behavior: {
				Key: "TypeUID"
			}
		}
		, Favorites: {
			Name: 'Share-Forms-Favorites'
			, Rows: 'CacheData.Favorites'
			, Behavior: {
				rootRefresh: true
			}
		}
		, Channels: {
			Name: 'Share-Channels'
			, Rows: 'CacheData.Channels'
			, Behavior: {
				Key: "DataUID"
			}
		}
		, Labels: {
			Name: 'Share-Labels'
			, Rows: 'CacheData.Labels'
			, Row: 'Label'
			, Behavior: {
				Key: "DataUID"
			}
		}
		, Circles: {
			Name: 'Share-Circles'
			, Rows: 'CacheData.Circles'
			, Behavior: {
				Key: "DataUID"
			}
		}
		, Config: {
			Name: 'Share-Config'
			, Rows: 'CacheData.Config'
			, Behavior: {
				singleRow: true
			}
		}
		, Session: {
			Name: 'Share-Session'
			, Rows: 'Session'
			, Behavior: {
				singleRow: true
			}
		}
		, Messages: {
			Name: 'Share-Messages'
			, Rows: 'CacheData.Messages'
			, Row: 'Message'
			, Behavior: {

			}
		}
		, Supports: {
			Name: 'Share-Supports'
			, Rows: 'CacheData.Supports'
			, Row: 'Support'
			, Behavior: {

			}
		}
		, Market: {
			Name: 'Share-Markets'
			, Rows: 'CacheData.Markets'
			, Row: 'Market'
			, Behavior: {

			}
		}
	}

};

var getDefinitions = function (iKey) {
	var fReturn = {};
	if (iKey) {
		var fKeys = iKey.split(',');

		fKeys.forEach(function (fId) {
			fReturn[fId] = SiteDefinitions[fId];
		});

		return fReturn;
	} else {
		return SiteDefinitions;
	}
}

var getDef = function (iKey) {
	var fReturn = {};
	if (iKey) {
		var fKeys = iKey.split(',');
		if (1 < fKeys.length) {
			fKeys.forEach(function (fId) {
				fReturn[fId] = SiteDefinitions[fId];
			});
		} else {
			fReturn = SiteDefinitions[iKey];
		}

		return fReturn;
	} else {
		return SiteDefinitions;
	}
}

var getSrv = function (iKey) {
	var fReturn = {};
	if (iKey) {
		var fKeys = iKey.split(',');

		fKeys.forEach(function (fId) {
			fReturn[fId] = SiteDefinitions.Services[fId];
		});

		//console.log('Geting service', fReturn);
		return fReturn;
	} else {
		return SiteDefinitions.Services;
	}
}

var getSrvObject = function (iTypeUID, iRows) {
	return {
		SqlName: 'Share-Objects',
		TypeUID: iTypeUID,
		Rows: iRows,
		Behavior: {
			Key: "ObjectUID"
		}
	}
}

module.exports.getDef = getDef;
module.exports.getDefinitions = getDefinitions;
module.exports.getSrv = getSrv;
module.exports.getSrv = getSrv;
module.exports.getSrvObject = getSrvObject;


//////////////////
// WEBPACK FOOTER
// ./ractive/Project/ERP/definitions.js
// module id = 13
// module chunks = 0